import { FC } from 'react';
import { useTranslation } from 'src/hooks/use-translation';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material';

import LockIcon from 'icons/monochrome/lock.svg';
import { SUPPORT_CONTACT_URL } from 'src/config-global';

export const TariffLockedView: FC = () => {
  const theme = useTheme();
  const { t } = useTranslation('', { keyPrefix: 'tariff.locked-page' });

  const handleContactSupport = () => {
    window.open(SUPPORT_CONTACT_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={2}
      sx={{ minHeight: '60vh', textAlign: 'center', px: 3 }}
    >
      <Box
        sx={{
          width: 96,
          height: 96,
          bgcolor: 'primary.lighter',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <LockIcon width={48} height={48} style={{ color: theme.palette.primary.main }} />
      </Box>

      <Typography variant="h4">{t('title')}</Typography>

      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 420 }}>
        {t('description')}
      </Typography>

      <Button variant="contained" color="primary" onClick={handleContactSupport}>
        {t('contact-support')}
      </Button>
    </Stack>
  );
};
